import React from 'react';
import { Box, Typography } from '@mui/material';
import RadialGauge from '../components/RadialGauge';
import WidgetWrapper from './WidgetWrapper';

const Gauge = ({
  value = 0,
  min = 0,
  max = 100,
  unit = '',
  title = '',
  color = '#4caf50',
  warningThreshold = 70,
  dangerThreshold = 90,
  startAngle = -90, // Default: start from top
  endAngle = 270,   // Default: full circle except small gap
  tagId = null,
  tagValue = null, // Will be injected by preview mode
  numberFormat = null, // { decimals, decimalSeparator, thousandsSeparator }
  // Zone properties
  normalZoneEnd = 70,     // Normal zone: 0-70%
  warningZoneEnd = 90,    // Warning zone: 70-90%
  showZones = true,       // Show colored zones
  normalColor = '#4caf50',  // Normal zone color
  warningColor = '#ff9800', // Warning zone color
  dangerColor = '#f44336',  // Danger zone color
  // Style properties
  backgroundColor,
  foreColor,
  borderWidth,
  borderColor,
  borderRadius,
  fontSize,
  fontWeight,
  fontFamily,
  opacity,
  // Size properties
  width,
  height,
  ...props
}) => {
  // Use tag value if available, otherwise use static value
  const currentValue = tagValue !== null && tagValue !== undefined ? tagValue : value;

  // Debug logging for size

  // Debug logging
  if (tagId && tagValue !== null && tagValue !== undefined) {
  }

  const getColor = () => {
    const percentage = ((currentValue - min) / (max - min)) * 100;
    if (percentage >= dangerThreshold) return '#f44336';
    if (percentage >= warningThreshold) return '#ff9800';
    return color;
  };

  // Context menu handler - dispatches global event
  const handleContextMenu = (event) => {
    if (tagId) {
      event.preventDefault();
      event.stopPropagation();

      // Dispatch global event to open Tag Info Modal
      const tagInfoData = {
        tagId: tagId,
        tagName: title || `Gauge ${tagId}`,
        tagName2: '',
        currentValue: currentValue,
        unit: unit || ''
      };
      window.dispatchEvent(new CustomEvent('openTagInfo', { detail: tagInfoData }));
    } else {
    }
  };

  return (
    <WidgetWrapper
      backgroundColor={backgroundColor}
      foreColor={foreColor}
      borderWidth={borderWidth}
      borderColor={borderColor}
      borderRadius={borderRadius}
      fontSize={fontSize}
      fontWeight={fontWeight}
      fontFamily={fontFamily}
      opacity={opacity}
      onContextMenu={handleContextMenu}
      {...props}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          padding: 1
        }}
      >
        {title && (
          <Typography 
            variant="caption" 
            sx={{ 
              mb: 1, 
              color: 'inherit',
              fontSize: 'inherit',
              fontWeight: 'inherit'
            }}
          >
            {title}
          </Typography>
        )}
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <RadialGauge
            value={currentValue}
            min={min}
            max={max}
            unit={unit}
            color={getColor()}
            startAngle={startAngle}
            endAngle={endAngle}
            normalZoneEnd={normalZoneEnd}
            warningZoneEnd={warningZoneEnd}
            showZones={showZones}
            normalColor={normalColor}
            warningColor={warningColor}
            dangerColor={dangerColor}
            numberFormat={numberFormat}
            size={Math.min(width || 100, height || 100) * 0.8}
          />
        </Box>
      </Box>
    </WidgetWrapper>
  );
};

export default Gauge;